export default class TableColumn {

    static NAME = 'name';
    static DOG = 'dog';
    static CONTRACT_STATUS = 'contractStatus';
    static AGE = 'age';
    static EMAIL = 'email';
    static PHONE = 'phone';
    static PHONE_MOBILE = 'phoneMobile';
    static EMERGENCY_CONTACT = 'emergencyContact';
    static BOOKED_AT = 'bookedAt';
    static CANCELED_AT = 'canceledAt';
    static REPLIED_AT = 'repliedAt';
    static ATTENDEE_STATUS = 'attendeeStatus';
    static COMMENT = 'comment';
    static CONTRACT_END = 'contractEnd';
    static DEPARTMENTS = 'departments';
    static ADDRESS_PARTICIPANT = 'addressParticipant';
    static INFORMED_AT = 'informedAt';
    static STATUS_WAITLIST = 'statusWaitlist';

    static TABLE_TYPE_PARTICIPANTS = 'participants';
    static TABLE_TYPE_CANCELLATIONS = 'cancellations';
    static TABLE_TYPE_WAITLIST = 'waitlist';
    static TABLE_TYPE_ACCEPTED = 'accepted';
    static TABLE_TYPE_REJECTED = 'rejected';
    static TABLE_TYPE_UNSURE = 'unsure';
    static TABLE_TYPE_ATTENDANCE = 'attendance';

    static WAITLIST_COLUMNS = [TableColumn.INFORMED_AT, TableColumn.STATUS_WAITLIST];

    static fromData(data) {
        if (!data) {
            return;
        }

        let tableColumn = new TableColumn();
        tableColumn.key = data.key;
        tableColumn.title = data.translationKey;

        return tableColumn;
    }
}
